var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAusimmLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 199,
    height: 48,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Section/Footer-2",
    transform: "translate(-741 -115)",
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Section/Footer",
    transform: "translate(486 115)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(255)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.272 8.577h-20.096v20.417h6.271V13.968h4.805v15.026h6.347V13.968h2.27c2.34 0 2.715.41 2.715 2.897v12.13h6.271V16.207c0-5.35-2.565-7.63-8.583-7.63",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.894 8.577h-.575v20.417h6.268V13.97h4.803v15.025h6.347V13.97h2.274c2.335 0 2.714.408 2.714 2.896v12.13h6.268V16.205c0-5.346-2.568-7.629-8.58-7.629h-19.519z",
    id: "Fill-3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-6",
    d: "M130.026 28.996h6.25V8.577h-6.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.976 13.383c-3.833 0-5.701 1.661-5.701 5.07 0 3.226 1.784 4.894 5.443 4.894h7.602c1.37 0 1.37.239 1.37.792 0 .497 0 .704-1.566.704h-12.281v4.152h13.004c3.82 0 5.676-1.624 5.676-4.973 0-3.272-1.615-4.834-5.243-4.834h-8.038c-1.131 0-1.131-.358-1.131-.694 0-.632.116-1.01 1.545-1.01h12.328v-3.972l-13.008-.129z",
    id: "Fill-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.062 20.68l3.875-7.218 3.958 7.219h-7.833zM76.01 8.578h-7.948L56.91 28.995h6.8l1.994-3.397h12.44l1.967 3.397h6.85L76.01 8.577z",
    id: "Fill-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.254 13.204h-5.382v11.073H94.9c-1.776 0-2.043-.255-2.043-1.95v-9.123H87.48v9.437c0 4.18 2.095 6.043 6.803 6.043h11.971v-15.48z",
    id: "Fill-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7 6.328h11.568V0h-13.71c-3.57 0-6.376.92-8.925 2.425C20.085.92 17.278 0 13.71 0H0v6.328h11.568c4.695 0 8.07 1.588 11.275 4.013l2.981 2.256a24.584 24.584 0 00-2.412 1.627c-.129.096-.398.3-.779.588l-.777-.588c-3.205-2.427-6.58-4.013-11.276-4.013H0v6.326h8.442c3.513 0 6.287.89 8.804 2.352l-3.513 2.658c-1.85-.718-3.892-1.127-6.271-1.127H0v6.327h5.32c4.695 0 8.071 1.589 11.276 4.013.128.099.4.303.786.596l-3.09 2.339c-2.824-1.882-5.894-3.064-9.942-3.064H0v6.326h2.195c4.694 0 8.072 1.588 11.275 4.014l3.905 2.954L21.7 47.2l.19.142.334.254.41.31 9.162-6.934c3.205-2.426 6.582-4.014 11.277-4.014h2.195v-6.326h-4.35c-4.694 0-8.072 1.586-11.275 4.012l-7.01 5.304-3.05-2.308c4.508-3.411 8.462-6.403 9.088-6.879 3.204-2.424 6.581-4.013 11.276-4.013h5.32V20.42h-7.461c-4.695 0-8.072 1.588-11.277 4.013l-3.896 2.948-3.055-2.312c3.098-2.344 5.495-4.157 5.97-4.518 3.204-2.426 6.581-4.014 11.276-4.014h8.444v-6.326H34.687a19.2 19.2 0 00-1.44.056l-4.348-3.291a17.505 17.505 0 014.8-.648",
    id: "Fill-13"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAusimmLogoWhite);
export default __webpack_public_path__ + "static/media/ausimm-logo-white.a765ac909a85b420eec0d5e229383d0b.svg";
export { ForwardRef as ReactComponent };